import { MinusIcon, PlusIcon } from '@/components/icons';
import { ZoomControlButton } from '@/components/feature/floor-guide/zoom-control-button';
import { useTranslation } from 'react-i18next';

type Props = {
    onZoomIn?: () => void;
    onZoomOut?: () => void;
    disabledZoomIn?: boolean;
    disabledZoomOut?: boolean;
    tabIndex?: number;
    regionOrder?: number;
};

export const ZoomControlBtnGroup = ({ onZoomIn, onZoomOut, disabledZoomIn, disabledZoomOut, tabIndex, regionOrder = 4 }: Props) => {
    const { t } = useTranslation();

    return (
        <section
            className="shadow-zoom-control-btn flex w-fit flex-col items-stretch justify-center rounded-t-md rounded-b-md"
            data-region-nav
            data-region-order={regionOrder}
        >
            <ZoomControlButton
                tabIndex={tabIndex}
                role="button"
                aria-label={t('floor_guide.button.zoom_in_on_the_map')}
                data-interactive
                icon={<PlusIcon />}
                className="rounded-t-md"
                onClick={() => (disabledZoomIn ? undefined : onZoomIn?.())}
                aria-disabled={disabledZoomIn}
                data-role={t('common.data_role.button')}
            >
            </ZoomControlButton>


            <ZoomControlButton
                tabIndex={tabIndex}
                role="button"
                aria-label={t('floor_guide.button.zoom_out_on_the_map')}
                data-interactive
                icon={<MinusIcon />}
                className="rounded-b-md"
                onClick={() => (disabledZoomOut ? undefined : onZoomOut?.())}
                aria-disabled={disabledZoomOut}
                data-role={t('common.data_role.button')}
            >
            </ZoomControlButton>
        </section>
    );
};
